import MainLayout from "layouts/MainLayout";
import { Link } from "react-router-dom";
import SelectedWorkCard from "components/landing/SelectedWorkCard";
import { ReactTyped } from "react-typed";

// Importing Utils
import SplashCursor from "utils/SplashCursor"
import BackToAllProjects from "components/common/BackToAllProjects";

const OrchardDesign = () => {
    return (
        <>
            <MainLayout>
                <div
                    className={` 
                transition-opacity duration-[800ms] px-6`
                    }
                >
                    <SplashCursor />

                    <section id="hero">
                        <div className="flex flex-col h-full" style={{ height: '40vh' }}>
                            <div className="flex flex-col justify-center h-full">
                                <h1 className="pt-10 pb-2 md:pb-4 text-xl font-zalando tracking-normal hero-text opacity-0 transition-opacity duration-1000  animate-fade-in-2a ">To
                                    <span className="tracking-[-1%] text-[#87db00]">
                                        {" "}
                                        <ReactTyped
                                            strings={["Orchard Design Studio", "Keith", "Christine", "Mahya", "Kayla", "Rachel"]}
                                            typeSpeed={60}
                                            loop
                                            backDelay={1800}
                                            backSpeed={20}
                                            cursorChar=","
                                            showCursor={true}
                                        />
                                    </span>{" "}
                                </h1>
                                <h1 className="font-zalando md:pb-4 text-xl tracking-tight hero-text opacity-0 transition-opacity duration-1000 delay-0 animate-fade-in-2a-after-1 ">From Sahir Prajapati,</h1>
                                <h1 className="mt-10 text-xl font-zalando tracking-tight hero-text opacity-0 transition-opacity animate-fade-in-2a-after-2 ">a cover letter; </h1>
                            </div>
                        </div>
                    </section>

                    <section id="start" className="mt-[4vh] opacity-0 transition-opacity animate-fade-in-2a-after-3">
                        <div className="md:max-w-[50vw]">
                            <p className="text-xl font-zolando">Hi, I'm Sahir, a mutidisciplinary designer with more than half a decade experience working across both startups, and agency environments.I focus on crafting engaging digital experiences that blend aesthetics with functionality, specializing in website design and branding to help businesses communicate their story effectively.</p>

                            <p className="mt-8 text-xl font-zolando">I’m drawn to Orchard Design Studio because of the diverse projects you’ve executed, everything from banners to websites to promotional videos. Not to forget, the way your design strategy and marketing work together, so cohesively. The opportunity to contribute to your team and learn from experienced professionals excites me.</p>

                            <p className="mt-8 text-xl font-zolando">With a background in computer programming, I bring a unique perspective that bridges design intent with technical feasibility, allowing me to consider visual decisions from both design and technical standpoints. I thrive in collaborative environments where feedback is constant, and ideas move quickly. Whether developing a brand identity or crafting a website, I approach each project with curiosity and a focus on the target audience while challenging norms where possible.</p>

                            <p className="mt-8 text-xl font-zolando">Thank you for considering my application! You can view some of my work <Link to="/projects" className="text-pink-500">here</Link> and some design stuff I do for fun <Link to="http://www.instagram.com/zennie.visuals" className=" bg-clip-text text-transparent bg-gradient-to-r from-[#ee2a7b] to-[#6228d7]" target="_blank">@zennie.visuals</Link>. My resume and contact details have been attached with the email which contained the link to this page. I look forward to the possibility of working together! </p>

                            <p className="mt-8 text-xl font-zolando">Regards, <br />Sahir. </p>
                        </div>
                    </section>

                    <section id="quick-links" className="mt-[8vh] opacity-0 transition-opacity animate-fade-in-2a-after-3">
                        <div>
                            <h1 className="text-[3rem] md:text-[5rem] text-center md:text-left text-[#a9eb3d] tracking-tight">
                                relevant projects
                            </h1>
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-x-5 gap-y-3">
                                <SelectedWorkCard
                                    linkTo="/projects/sworna"
                                    imgSrc="https://atypicalcms.com/assets/bb0298bc-14da-4e62-9433-8ab48654080b?format=webp"
                                    altText="sworna"
                                    projectName="Sworna"
                                    textColor="red"
                                    assetStyles="min-w-full min-h-[50vh] max-h-[50vh] object-cover rounded-[1vh] transform object-cover duration-200 hover:scale-[103%] overflow-hidden "
                                    fullDivClasses="hover:saturate-100 rounded-md"
                                    tags={["Branding", "Marketing", "Social Media"]}
                                />

                                <SelectedWorkCard
                                    linkTo="/projects/cacee"
                                    imgSrc="https://atypicalcms.com/assets/9da93dca-1c08-4ec7-8d46-568b7b06ba89"
                                    altText="CACEE"
                                    projectName="CACEE"
                                    textColor="blue"
                                    assetStyles="min-w-full min-h-[50vh] max-h-[50vh] object-cover rounded-[1vh] transform object-cover duration-200 hover:scale-[103%] overflow-hidden "
                                    fullDivClasses="hover:saturate-100 rounded-md"
                                    tags={["Branding", "Print Design", "Social Media"]}
                                />

                                <SelectedWorkCard
                                    linkTo="/projects/rgcenter"
                                    imgSrc="https://atypicalcms.com/assets/9c1deb56-4bda-4fde-abc3-4045270f27ba"
                                    altText="RG Center"
                                    projectName="R.G. Center"
                                    textColor="gray"
                                    assetStyles="min-w-full min-h-[50vh] max-h-[50vh] object-cover rounded-[1vh] transform object-cover duration-200 hover:scale-[103%] overflow-hidden "
                                    fullDivClasses="hover:saturate-100 rounded-md"
                                    tags={["Website Design", "UI / UX", "Web Development"]}
                                />

                                <SelectedWorkCard
                                    linkTo="/projects/ocdyv"
                                    imgSrc="https://atypicalcms.com/assets/efda0344-2587-4d88-b279-f9f56f0f781d"
                                    altText="Ocdyv"
                                    projectName="Ocdyv"
                                    textColor="green"
                                    assetStyles="min-w-full min-h-[50vh] max-h-[50vh] object-cover rounded-[1vh] transform object-cover duration-200 hover:scale-[103%] overflow-hidden "
                                    fullDivClasses="hover:saturate-100 rounded-md"
                                    tags={["Website Design", "UI / UX"]}
                                />
                            </div>
                            <BackToAllProjects customStyle="text-center text-[1.7rem] text-[#87db00] mt-10" customText="< view all projects >" />
                        </div>
                    </section>
                </div>
            </MainLayout>
        </>
    )
}

export default OrchardDesign;